export default function CTASection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 gap-0 rounded-2xl overflow-hidden shadow-2xl">
          <div className="relative bg-[#e8dcc8] p-16 flex items-end">
            <div
              className="absolute inset-0 bg-cover bg-center"
              style={{
                backgroundImage: 'url(https://public.readdy.ai/ai/img_res/879ce3cb1aecbc5b7edb7d2db1c90a8e.jpg)',
              }}
            ></div>
            <div className="relative z-10">
              <p className="text-sm text-gray-600 mb-2">Get Started Today</p>
              <h3 className="text-3xl font-medium text-black mb-1">Fast, Reliable,</h3>
              <h3 className="text-5xl font-bold text-black mb-1">Professional</h3>
              <h3 className="text-3xl font-medium text-black">Service</h3>
            </div>
          </div>

          <div className="bg-white p-16 flex flex-col items-center justify-center text-center">
            <h3 className="text-4xl font-bold text-[#1a2b4a] mb-6">
              Ready to Streamline Your Legal Document Services?
            </h3>
            <p className="text-base text-gray-600 mb-8 leading-relaxed max-w-lg">
              Whether you need a single document served or comprehensive case management for your law firm, our team is ready to help. Create your client account today and experience the difference professional service makes.
            </p>
            <button className="px-8 py-3.5 bg-[#5a4a3a] text-white text-base font-medium rounded-full hover:bg-[#4a3a2a] transition-colors cursor-pointer whitespace-nowrap mb-4">
              Create Client Account →
            </button>
            <p className="text-sm text-gray-500">No setup fees • Cancel anytime • 24/7 support</p>
          </div>
        </div>
      </div>
    </section>
  );
}
